import { StockPickResponse } from './../../../../models/stock-pick/stock-pick-response.model';
import { StockPickService } from './../../../../services/inbound/stock-pick.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { NgIf } from '@angular/common';
import { RadioButtonModule } from 'primeng/radiobutton';
import { FormsModule } from '@angular/forms';
import { Button } from 'primeng/button';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'stock-pick',
    templateUrl: './stock-pick.component.html',
    styleUrls: ['./stock-pick.component.scss'],
    imports: [DialogModule, NgIf, RadioButtonModule, FormsModule, Button, TranslatePipe]
})
export class StockPickComponent implements OnInit {

	@Output() onEmitStockTypeUidK = new EventEmitter();

	displayModal: boolean;

	selectedValue: string;

	stocks: StockPickResponse[];
	selectedStock: StockPickResponse

	constructor(
		private stockPick: StockPickService
	) {
		this.stockPick = stockPick;
	}

	ngOnInit(): void {
		this.displayModal = true;
		this.getStock();
	}

	getStock(): void {
		this.stockPick.getStockType()
			.subscribe(stock => this.stocks = stock);
	}

	closeDialog() {
		if (this.selectedValue != null) {
			this.displayModal = false;
			this.selectedStock = this.stocks.filter(stock => stock.stockTypeUidK === Number(this.selectedValue))[0];
			this.onEmitStockTypeUidK.emit(this.selectedStock);
		}
	}

}

